module.exports = __webpack_public_path__ + "img/arrow-right.326c875e.svg";